/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import LazyLoad from 'react-lazyload';
import PropTypes from 'prop-types';

/* eslint-disable react/jsx-props-no-spreading */
const LazyImage = (props) => {
    const {
        srcSet, src, alt, imgClass, height, ...rest
    } = props;

    return (
        <LazyLoad height={height}>
            {srcSet && <source data-srcset={srcSet} type="image/webp" {...rest} />}
            <img className={`lazy ${imgClass}`} alt={alt} srcSet={srcSet} src={`${process.env.PUBLIC_URL}/static/images/placeholder.png`} data-src={src || srcSet} {...rest} />
        </LazyLoad>
    );
};

LazyImage.defaultProps = {
    alt: '',
    height: '100%',
    width: '100%',
    imgClass: '',
};

LazyImage.propTypes = {
    srcSet: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
    imgClass: PropTypes.string,
};

export default LazyImage;
